export default __webpack_public_path__ + "static/media/cheap_car_category.5ac05f0c.png";